angular
	.module 'App.Repository'

.factory 'JournalServiceRepository', ['$window', '$q', 'BaseRepository', ($window, $q, BaseRepository) ->
	class JournalServiceRepository extends BaseRepository
		@resource = '/journal_service'
		@isRestricted = true

		download: (query = null) ->
			if _.isEmpty query
				query = @createQuery()

			$window.location.href = @toString(query, '/download')

		listRegisters: (shopId = null) ->
			url = if shopId != null then "distinct/shops/#{shopId}/registers" else 'distinct/registers'

			return @find(url)
				.then (response) =>
					return response.data
				.catch =>
					return []

		listShops: ->
			return @find('distinct/shops')
				.then (response) =>
					return response.data
				.catch =>
					return []

	return new JournalServiceRepository
]
